const Logo = () => {
    return <div className="basis-8/12 text-4xl tracking-widest font-semibold">MUNTHE</div>;
}

export default Logo;